module.exports = __webpack_public_path__ + "img/1437960394.75ea9eb4.jpg";